(function($) {

	$(document).ready(function() {
		var menu = document.querySelector('#wrapper-navbar');
		var bmBtn = document.querySelector('.mega-menu-toggle');
		var html = document.querySelector('html');
		var navLogo = document.querySelector('.navbar-brand');
		var menuPrevent = document.querySelector('.menu-prevent');
		var heroHeader = document.querySelectorAll('.dynamic-img');
		var dropdowns = document.querySelectorAll('.concertina-header');

		var allPrevent = document.querySelectorAll('.menu-prevent');

		if (bmBtn) {
			bmBtn.addEventListener('click', function() {
				menu.classList.toggle('mb-menu-active');
				html.classList.toggle('no-scroll');

				if (navLogo) {
					var logo = navLogo.querySelector('.logo');
					var menuLogo = navLogo.querySelector('.mobile-menu-logo');

					if (! navLogo.classList.contains('grey-background')) {
						logo.classList.toggle('d-none');
						menuLogo.classList.toggle('d-none');
						menuLogo.classList.toggle('mobile-toggle');
					} else {
						logo.classList.toggle('mobile-toggle');
					}


					if (logo.classList.contains('mobile-toggle') || menuLogo.classList.contains('mobile-toggle')) {
						navLogo.addEventListener('click', function() {
							bmBtn.click();
						});
					}
				}

				if (menuPrevent) {
					if (menuPrevent.classList.contains('first-click')) {
						menuPrevent.classList.remove('mega-toggle-on');
						menuPrevent.classList.remove('first-click');
					}
				}
			});
		}

		if (menuPrevent) {
			$(allPrevent).each(function() {
				this.addEventListener('click', function() {
					if (this.classList.contains('first-click')) {
						this.classList.remove('mega-toggle-on');
						this.classList.remove('first-click');
					} else {
						if (this.classList.contains('mega-toggle-on')) {
							this.classList.add('first-click');
						}
					}
				});
			});
		}

		$(window).resize(function(){
			var win = $(this); //this = window
			if (win.width() >= 768 && html.classList.contains('no-scroll')) {
				bmBtn.click();
			}
		});

		if (dropdowns) {
			var acc = document.getElementsByClassName("concertina-header");
			var i;

			for (i = 0; i < acc.length; i++) {
				acc[i].addEventListener("click", function(e) {
					e.preventDefault()

					/* Toggle between hiding and showing the active panel */
					var open = this.nextElementSibling;
					if (open.classList.contains("hidden")) {
						open.classList.remove("hidden");

					} else {
						open.classList.add("hidden");
					}
				});
			}
		}

		if (heroHeader) {
			let currentIndex = 0;

			const updateHeaderImg = () => {
				var findHeroImg = document.querySelectorAll('.dynamic-img');

				if (findHeroImg.length > 1) {
					currentIndex = currentIndex + 1;

					if (currentIndex === findHeroImg.length) {
						resetIndexes();
					}

					$(findHeroImg).each(function(i) {
						if (currentIndex === i) {
							$(this).addClass("show-img");
							$(this).addClass("animation");
						} else {
							$(this).removeClass("show-img");
							$(this).removeClass("animation");
						}

						i++
					});
				}
			};

			function resetIndexes(){
				currentIndex = 0;
			}

			setInterval(updateHeaderImg, 7000);
		}

	})

})(jQuery);

(function($) {

	// Sticky items scroll

	var animation_blocks = document.querySelectorAll('.block');
	var news_pt = document.querySelectorAll('.news-archive-container');
	var cs_pt = document.querySelectorAll('.case-studies-archive-container');

	if (animation_blocks) {
		function revealBlocks () {
			var block = document.querySelectorAll('.block');
			var footer = document.querySelectorAll('.footer-container');
			var imgBlock = document.querySelectorAll('.img-block');
			var imgBlockTxt = document.querySelectorAll('.caption-content');

			for(var i = 0; i < block.length; i++) {
				var windowheight = window.innerHeight;
				var revealTop = block[i].getBoundingClientRect().top;
				var revealpoint = 130;

				if (revealTop < windowheight - revealpoint) {
					block[i].classList.add('block-animation');
				}
			}

			for(var i = 0; i < imgBlock.length; i++) {
				var windowheight = window.innerHeight;
				var revealTop = imgBlock[i].getBoundingClientRect().top;
				var revealpoint = 40;

				if (revealTop < windowheight - revealpoint) {
					imgBlock[i].classList.add('block-animation');
				}
			}

			for(var i = 0; i < imgBlockTxt.length; i++) {
				var windowheight = window.innerHeight;
				var revealTop = imgBlockTxt[i].getBoundingClientRect().top;
				var revealpoint = 0;

				if (revealTop < windowheight - revealpoint) {
					imgBlockTxt[i].classList.add('text-animation');
				}
			}

			for(var i = 0; i < footer.length; i++) {
				var windowheight = window.innerHeight;
				var revealTop = footer[i].getBoundingClientRect().top;
				var revealpoint = 130;

				if (revealTop < windowheight - revealpoint) {
					footer[i].classList.add('block-animation');
				}
			}
		}

		revealBlocks();

		window.addEventListener('scroll', revealBlocks);
	}

	if (news_pt) {
		function revealNewsBlocks () {
			var news_arc = document.querySelectorAll('.news-archive-container');

			for(var i = 0; i < news_arc.length; i++) {
				var windowheight = window.innerHeight;
				var revealTop = news_arc[i].getBoundingClientRect().top;
				var revealpoint = 130;

				if (revealTop < windowheight - revealpoint) {
					news_arc[i].classList.add('block-animation');
				}
			}
		}

		revealNewsBlocks();

		window.addEventListener('scroll', revealNewsBlocks);
	}

	if (cs_pt) {
		function revealCSBlocks () {
			var cs_arc = document.querySelectorAll('.case-studies-archive-container');

			for(var i = 0; i < cs_arc.length; i++) {
				var windowheight = window.innerHeight;
				var revealTop = cs_arc[i].getBoundingClientRect().top;
				var revealpoint = 130;

				if (revealTop < windowheight - revealpoint) {
					cs_arc[i].classList.add('block-animation');
				}
			}
		}

		revealCSBlocks();

		window.addEventListener('scroll', revealCSBlocks);
	}

})(jQuery);

// Slider.js functionality

(function($) {

	// Slider.js
	$('.news-relevancy-container').not('.slick-initialized').slick({
		dots: false,
		infinite: true,
		arrows: true,
		loop: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: false,
		responsive: [
			{
				breakpoint: 767.98,
				settings: {
					centerMode: true,
					variableWidth: true,
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}
		]
	});

	$('.gallery-container').not('.slick-initialized').slick({
		dots: false,
		infinite: true,
		arrows: true,
		loop: true,
		slidesToShow: 3,
		slidesToScroll: 1,
		autoplay: false,
		responsive: [
			{
				breakpoint: 767.98,
				settings: {
					slidesToShow: 1,
					slidesToScroll: 1,
				}
			}
		]
	});

	$('.relevancy-testimonial-content-container').not('.slick-initialized').slick({
		dots: false,
		infinite: true,
		arrows: true,
		loop: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: false
	});

	$('.slider-container').not('.slick-initialized').slick({
		centerMode: true,
		dots: false,
		infinite: true,
		arrows: true,
		loop: true,
		slidesToShow: 3,
		slidesToScroll: 2,
		autoplay: false,
		variableWidth: true,
		responsive: [
			{
				breakpoint: 1199.98,
				slidesToShow: 1,
				slidesToScroll: 2,
			},
			{
				breakpoint: 991.98,
				settings: "unslick"
			}
		]
	});

	changeSlickArrows();

	$(window).resize(function(){
		const isDesktop = $(window).width() > 991;

		if (isDesktop) {
			$('.news-relevancy-container').not('.slick-initialized').slick({
				dots: false,
				infinite: true,
				arrows: true,
				loop: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				autoplay: false,
				responsive: [
					{
						breakpoint: 767.98,
						settings: {
							centerMode: true,
							variableWidth: true,
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					}
				]
			});

			$('.gallery-container').not('.slick-initialized').slick({
				dots: false,
				infinite: true,
				arrows: true,
				loop: true,
				slidesToShow: 3,
				slidesToScroll: 1,
				autoplay: false,
				responsive: [
					{
						breakpoint: 767.98,
						settings: {
							slidesToShow: 1,
							slidesToScroll: 1,
						}
					}
				]
			});

			$('.slider-container').not('.slick-initialized').slick({
				centerMode: true,
				dots: false,
				infinite: true,
				arrows: true,
				loop: true,
				slidesToShow: 3,
				slidesToScroll: 2,
				autoplay: false,
				variableWidth: true,
				responsive: [
					{
						breakpoint: 1199.98,
						slidesToShow: 1,
						slidesToScroll: 2,
					},
					{
						breakpoint: 991.98,
						settings: "unslick"
					}
				]

			});
		}

		changeSlickArrows();
	});

})(jQuery);

// Slider.js arrows inject

function changeSlickArrows() {

	if (document.querySelectorAll('.slick-next.slick-arrow')) {
		document.querySelectorAll('.slick-next.slick-arrow').forEach(next => {
			next.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path class="cls-1" d="m26.67,31.58l4.66-4.66c1.06-1.06,1.06-2.78,0-3.84l-4.66-4.66"/><line class="cls-1" x1="32.12" y1="25" x2="17.88" y2="25"/></svg>';
		});
	}

	if (document.querySelectorAll('.slick-prev.slick-arrow')) {
		document.querySelectorAll('.slick-prev.slick-arrow').forEach(prev => {
			prev.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 50 50"><path fill="none" stroke-linecap="round" stroke-miterlimit="10" stroke-width class="cls-1" d="m23.33,18.42l-4.66,4.66c-1.06,1.06-1.06,2.78,0,3.84l4.66,4.66"/><line class="cls-1" x1="17.88" y1="25" x2="32.12" y2="25"/></svg>';
		});
	}

}

changeSlickArrows();

function galleryShow() {
	var galleryBlock = document.querySelector('.gallery-block');
	var html = document.querySelector('html');

	if (galleryBlock) {
		var galleryOverlay = galleryBlock.querySelector('.gallery-overlay');
		var galleryClose = galleryBlock.querySelector('.gallery-close');
		var galleryActiveCont = document.querySelector('.gallery-active-container');

		galleryClose.addEventListener('click', function () {
			galleryOverlay.classList.toggle('active');
			galleryActiveCont.classList.toggle('animation');
			html.classList.toggle('no-scroll');
		});
	}
}
galleryShow();

(function($) {

	$(document).ready(function() {
		var galleryBlock = document.querySelector('.gallery-block');
		var galleryActivate = document.querySelector('.gallery-overlay');
		var galleryActiveCont = document.querySelector('.gallery-active-container');
		var html = document.querySelector('html');

		if (galleryBlock) {
			$('.gallery-image-container').on('click', function() {
				var activeImageContainer = document.querySelector('.gallery-active-image-container');
				var existingActiveImage = document.querySelector('.gallery-active-image');

				galleryActivate.classList.toggle('active');
				galleryActiveCont.classList.toggle('animation');
				html.classList.toggle('no-scroll');


				var activeImage = this.querySelector('.gallery-image');
				var activeImageHTML = activeImage.outerHTML;


				// Removing active image to make place for the image selected from carousel
				if (existingActiveImage) {
					existingActiveImage.remove();
				}

				// Adding carousel image into the missing active image position
				activeImageContainer.innerHTML = activeImageHTML

				// Removing and ammending the class of the carousel to be the active image class
				var removeChildClass = document.querySelector('.gallery-overlay .gallery-image');

				if (removeChildClass) {
					removeChildClass.classList.remove('gallery-image');
					removeChildClass.classList.add('gallery-active-image');
				}

			});
		}

		if (galleryActivate) {
			$(document).keydown(function(e) {
				// ESCAPE key pressed
				if (e.keyCode == 27) {

					if (galleryActivate.classList.contains('active')) {
						galleryActivate.classList.toggle('active');
						galleryActiveCont.classList.toggle('animation');
						html.classList.toggle('no-scroll');
					}
				}
			});
		}
	})

})(jQuery);

(function($) {
	let currentPage = 1;
	var isLoading = false; // Track whether an AJAX request is in progress

	$('#load-more-news').on('click', function(e) {
		e.preventDefault();

		if (isLoading) return; // Prevent multiple simultaneous requests

		isLoading = true; // Set the loading flag

		var loader = document.querySelector('.loader');

		// Show the loading spinner
		if (loader.style.display) {
			$(".loader").show();
		} else {
			loader.classList.remove('d-none');
		}

		$(".load-more-btn").hide();

		currentPage++; // Do currentPage + 1, because we want to load the next page

		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'html',
			data: {
				action: 'weichie_load_more',
				paged: currentPage,
			},
			success: function (res) {
				$('.news-archive-container').append(res);

				isLoading = false; // Reset the loading flag
				// Hide the loading spinner
				$(".loader").hide();
				$(".load-more-btn").show();

				console.log("Success");

				var cards = document.querySelectorAll('.news-item');

				for(var i = 0; i < cards.length; i++) {
					var windowheight = window.innerHeight;
					var revealTop = cards[i].getBoundingClientRect().top;
					var revealpoint = 0;

					if (revealTop < windowheight - revealpoint) {
						cards[i].classList.add('animation');
					}
				}
			}
		});
	});

})(jQuery);

(function($) {

	let currentPage = 1;
	var isLoading = false; // Track whether an AJAX request is in progress
	$('#load-more-case-studies').on('click', function(e) {
		e.preventDefault();

		if (isLoading) return; // Prevent multiple simultaneous requests

		isLoading = true; // Set the loading flag

		var loader = document.querySelector('.loader');

		// Show the loading spinner
		if (loader.style.display) {
			$(".loader").show();
		} else {
			loader.classList.remove('d-none');
		}

		$(".load-more-btn-cs").hide();

		currentPage++; // Do currentPage + 1, because we want to load the next page

		$.ajax({
			type: 'POST',
			url: '/wp-admin/admin-ajax.php',
			dataType: 'html',
			data: {
				action: 'weichie_load_more2',
				paged: currentPage,
			},
			success: function (res) {
				$('.case-studies-archive-container').append(res);

				isLoading = false; // Reset the loading flag
				// Hide the loading spinner
				$(".loader").hide();
				$(".load-more-btn-cs").show();

				var cards = document.querySelectorAll('.case-studies-item');

				for(var i = 0; i < cards.length; i++) {
					var windowheight = window.innerHeight;
					var revealTop = cards[i].getBoundingClientRect().top;
					var revealpoint = 0;

					if (revealTop < windowheight - revealpoint) {
						cards[i].classList.add('animation');
					}
				}
			}
		});
	});

	$(document).ready(function() {
		var videoModuleBlock = document.querySelector('.video-group-block');
		var modelActivate = document.querySelector('.video-group-overlay');
		var html = document.querySelector('html');

		if (videoModuleBlock) {
			$('.video-group-container').on('click', function() {
				var activeImageContainer = document.querySelector('.video-group-active-video-container');
				var existingVideo = document.querySelector('.video-group-video');

				modelActivate.classList.add('active')

				if (modelActivate.classList.contains('active')) {
					// Menu is open, disable scrolling
					html.classList.toggle('no-scroll');

				} else {
					// Menu is closed, enable scrolling
					html.classList.toggle('no-scroll');
				}


				var activeVideoID = this.querySelector('.video-player-id');
				existingVideo.src = activeVideoID.innerHTML;


			});
		}

		if (modelActivate) {
			$(document).keydown(function(e) {
				// ESCAPE key pressed
				if (e.keyCode == 27) {
					var existingVideo = document.querySelector('.video-group-video');
					modelActivate.classList.remove('active');

					if (modelActivate.classList.contains('active')) {
						// Menu is open, disable scrolling
						html.classList.toggle('no-scroll');


					} else {
						// Menu is closed, enable scrolling
						existingVideo.src = "";
						html.classList.toggle('no-scroll');
					}
				}
			});

			$('.video-group-close').on('click', function () {
				var existingVideo = document.querySelector('.video-group-video');
				modelActivate.classList.remove('active');

				if (modelActivate.classList.contains('active')) {
					// Menu is open, disable scrolling
					html.classList.toggle('no-scroll');

				} else {
					// Menu is closed, enable scrolling
					existingVideo.src = "";
					html.classList.toggle('no-scroll');
				}
			});
		}
	})

})(jQuery);

function hideLoadMore() {

	if (document.querySelector('.load-more-btn')) {
		document.querySelectorAll('.load-more-btn').forEach(button => {
			button.addEventListener('click', () => {
				let numOfPosts = button.dataset.posts;

				if (document.querySelectorAll('.news-archive-container .news')) {
					let numOfItems = document.querySelectorAll('.news-archive-container .news-item').length + 12;
					if (numOfItems >= numOfPosts) {
						button.style.display = 'none';
						document.querySelector('.load-more-container').remove();
					}
				}

			});
		});
	}

	if (document.querySelector('.load-more-btn-cs')) {
		document.querySelectorAll('.load-more-btn-cs').forEach(button => {
			button.addEventListener('click', () => {
				let numOfPosts = button.dataset.posts;

				if (document.querySelectorAll('.case-studies-archive-container .case-studies')) {
					let numOfItems = document.querySelectorAll('.case-studies-archive-container .case-studies-item').length + 12;

					if (numOfItems >= numOfPosts) {
						button.style.display = 'none';
						document.querySelector('.load-more-container').remove();
					}
				}
			});
		});
	}
}

hideLoadMore();